import { SelectOption } from '@navstation-portal/shared/data-model/common';
import { PrimeMoverTypes } from '../vessel-spec/prime-mover-types';

export interface PrimeMoverState {
  primeMoversType?: SelectOption | undefined;
}

export const PrimeMoverLabels = {
  two_stroke_engine: 'Two-Stroke Engine',
  four_stroke_engine: 'Four-Stroke Engine',
  diesel_electric_propulsion: 'Diesel-Electric Propulsion',
  lbsi: 'Lean-Burn Spark-Ignited',
  steam_turbine_propulsion: 'Steam Turbine Propulsion',
};

export const PRIME_MOVER_OPTIONS: SelectOption[] = [
  {
    code: PrimeMoverTypes.TWO_STROKE_ENGINE,
    name: PrimeMoverLabels.two_stroke_engine,
  },
  {
    code: PrimeMoverTypes.FOUR_STROKE_ENGINE,
    name: PrimeMoverLabels.four_stroke_engine,
  },
  {
    code: PrimeMoverTypes.DIESEL_ELECTRIC_PROPULSION,
    name: PrimeMoverLabels.diesel_electric_propulsion,
  },
  { code: PrimeMoverTypes.LBSI, name: PrimeMoverLabels.lbsi },
  {
    code: PrimeMoverTypes.STEAM_TURBINE_PROPULSION,
    name: PrimeMoverLabels.steam_turbine_propulsion,
  },
];
